import React, { useState } from "react";
import * as XLSX from "xlsx";
import {
  Tooltip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Modal,
  Box,
} from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { postJsonData } from "../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import ApiEndpoints from "../network/ApiEndPoints";
import CircularProgress from "@mui/material/CircularProgress";
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
  maxHeight: "80vh",
  overflowY: "auto",
};

const ExcelToJsonUploader = ({ bankId, setRequest, refresh, setQuery }) => {
  const [jsonData, setJsonData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [uploading, setUploading] = useState(false);
  const handleClose = () => {
    setIsModalOpen(false);
    setJsonData([]);
    setFileInputKey(Date.now());
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const parsedData = XLSX.utils.sheet_to_json(worksheet);

      setJsonData(parsedData);
      setIsModalOpen(true);
      okSuccessToast("File uploaded successfully. Review the data and upload.");
    } catch (error) {
      // apiErrorToast("Error reading file: " + error.message);
    }
  };
  const validateRow = (row) => {
    const credit = Number(row?.credit || 0);
    const debit = Number(row?.debit || 0);

    if (!row?.description || row.description.toString().trim() === "") {
      return "Description is required";
    }

    // Dono 0 nahi hone chahiye
    if (credit === 0 && debit === 0) {
      return "Either Credit or Debit must be greater than 0";
    }

    // Dono ek saath amount nahi hone chahiye
    if (credit > 0 && debit > 0) {
      return "Credit and Debit cannot both have values";
    }

    return null;
  };
  const handleRowUpload = (row, index) => {
    return new Promise((resolve) => {
      const data = {
        bankid: bankId,
        description: row?.description || "",
        credit: row?.credit || 0,
        debit: row?.debit || 0,
        remark: row?.remarks || "",
        mop: row?.mop || "",
      };

      console.log(`🚀 REQUEST -> Row ${index + 1}`, data);
      console.log(row.description);
      console.log(row.remarks);
      postJsonData(
        ApiEndpoints.ADD_BANK_TXN,
        data,
        setRequest,
        (response) => {
          console.log(`✅ SUCCESS -> Row ${index + 1}`, response);

          resolve({
            success: true,
            row: index + 1,
          });
        },
        (error) => {
          console.error(`❌ FAILED -> Row ${index + 1}`, error);

          resolve({
            success: false,
            row: index + 1,
            error,
          });
        },
      );
    });
  };
  const handleUploadAll = async () => {
    console.clear();
    setUploading(true);

    const BATCH_SIZE = 5;
    let success = 0;

    console.log("==================================");
    console.log("TOTAL ROWS :", jsonData.length);
    console.log("==================================");

    try {
      for (let i = 0; i < jsonData.length; i += BATCH_SIZE) {
        console.log(
          `========== BATCH ${i / BATCH_SIZE + 1} (${i + 1} - ${Math.min(
            i + BATCH_SIZE,
            jsonData.length,
          )}) ==========`,
        );

        // Batch ke andar sequential upload
        for (let j = 0; j < BATCH_SIZE && i + j < jsonData.length; j++) {
          const index = i + j;
          const row = jsonData[index];

          // Validation
          const validationError = validateRow(row);

          if (validationError) {
            apiErrorToast(`Row ${index + 1}: ${validationError}`);
            console.error(
              `❌ Validation Failed - Row ${index + 1}`,
              validationError,
            );
            setUploading(false);
            return;
          }

          // Upload
          const result = await handleRowUpload(row, index);

          if (!result.success) {
            apiErrorToast(`Upload stopped at Row ${result.row}`);
            console.error(`❌ Upload Failed - Row ${result.row}`, result.error);
            setUploading(false);
            return;
          }

          success++;
        }

        console.log(
          `✅ Batch ${i / BATCH_SIZE + 1} Completed. Uploaded: ${success}`,
        );

        // Next batch se pehle 500ms wait
        if (i + BATCH_SIZE < jsonData.length) {
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
      }

      console.log("==================================");
      console.log("UPLOAD COMPLETED");
      console.log("SUCCESS :", success);
      console.log("==================================");

      okSuccessToast(`${success} Transactions Uploaded Successfully`);

      refresh(setQuery);
      handleClose();
    } finally {
      setUploading(false);
    }
  };
  return (
    <div>
      {/* File Upload Input */}
      <Tooltip title="Upload Excel File">
        <IconButton color="primary" component="label">
          <UploadFile />
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            hidden
            key={fileInputKey}
          />
        </IconButton>
      </Tooltip>

      {/* Modal to Display Data */}
      <Modal open={isModalOpen} onClose={handleClose}>
        <Box sx={modalStyle}>
          <h2>Uploaded Data</h2>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Description</TableCell>
                  <TableCell>Credit</TableCell>
                  <TableCell>Debit</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell>MOP</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {jsonData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.description || "N/A"}</TableCell>
                    <TableCell>{row.credit || 0}</TableCell>
                    <TableCell>{row.debit || 0}</TableCell>
                    <TableCell>{row.remarks || "N/A"}</TableCell>
                    <TableCell>{row.mop || "N/A"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Upload All Button */}
          <Button
            variant="contained"
            color="primary"
            onClick={handleUploadAll}
            disabled={uploading}
            style={{ marginTop: "20px", minWidth: "170px" }}
          >
            {uploading ? (
              <>
                <CircularProgress
                  size={18}
                  color="inherit"
                  style={{ marginRight: 8 }}
                />
                Uploading...
              </>
            ) : (
              "Upload Excel"
            )}
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default ExcelToJsonUploader;
